interface LabelWithDetailProps {
  detail?: string | null;
  label: string;
}

export const LabelWithDetail = ({ label, detail }: LabelWithDetailProps) => (
  <>
    <span className="font-bold">{label}</span>
    {detail && (
      <>
        {" "}
        <span className="font-normal">({detail})</span>
      </>
    )}
  </>
);
